<div class="main-content mt-0">
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
        <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-7 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a class="btn btn-dark btn-sm btn-new" [routerLink]="['/marketing']">
            Keywords
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPageCampaigns/urlMapping']"
          >
            URL Mapping
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/onPage']"
          >
            On-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/internalLinks/add']"
          >
            Internal Links
          </a>
        </div>
      </div>
    </div>

    <div class="row pb-3">
      <div class="col-12 d-flex align-items-center justify-content-between">
        <div class="flex-grow-1 text-center">
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/technicalQa']"
          >
            Technical QA
          </a>
          <a class="btn btn-dark btn-sm btn-reg"> Local SEO </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/offPage']"
          >
            Off-Page
          </a>
          <a
            class="btn btn-dark btn-sm btn-new"
            [routerLink]="['/marketing/seo/performance']"
          >
            Performance
          </a>
        </div>
      </div>
    </div>
    <div class="url-mapping-container p-4" *ngIf="!loading">
      <!-- ── HEADER ─────────────────────────────────────────────────────── -->
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div class="d-flex align-items-center gap-3">
          <div class="header-icon bg-success text-white rounded p-2">
            <i class="fas fa-map-marker-alt fa-lg"></i>
          </div>
          <div class="pl-2">
            <h2 class="h4 mb-0 fw-bold">LOCAL SEO</h2>
            <!-- <p class="text-muted mb-0 small">
              Manage and optimize local presence, visibility and reputation for
              every market we serve.
            </p> -->
          </div>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-outline-secondary btn-sm p-1 btn-header">
            <i class="fas fa-download me-1"></i> Export Report
          </button>
        </div>
      </div>

      <!-- ── MAIN LAYOUT ────────────────────────────────────────────────── -->
      <div class="row">
        <div class="col-12">
          <!-- ── FILTERS ────────────────────────────────────────────────────── -->
          <div class="row mb-0 px-3">
            <div class="col-3">
              <label class="text-dark" for="urlMapping"
                ><strong>Filters</strong></label
              >
            </div>
            <div class="col-9 d-flex justify-content-end mt-2 pr-0">
              <button
                class="btn btn-outline-secondary btn-sm btn-filter"
                (click)="onFilterChange()"
              >
                Find
              </button>
            </div>
            <!-- Market Status -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Market Status</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingMarketStatus"
              >
                <option *ngFor="let m of marketStatuses" [value]="m.value">
                  {{ m.label }}
                </option>
              </select>
            </div>

            <!-- Universe -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Universe</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingUniverse"
              >
                <option *ngFor="let u of universes" [value]="u.value">
                  {{ u.label }}
                </option>
              </select>
            </div>

            <!-- Location -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Location</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingLocation"
              >
                <option *ngFor="let loc of locations" [value]="loc.value">
                  {{ loc.label }}
                </option>
              </select>
            </div>

            <!-- Service -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Service</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingService"
              >
                <option *ngFor="let s of services" [value]="s.value">
                  {{ s.label }}
                </option>
              </select>
            </div>

            <!-- Issue Type -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Issue Type</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingIssueType"
              >
                <option *ngFor="let it of issueTypes" [value]="it.value">
                  {{ it.label }}
                </option>
              </select>
            </div>

            <!-- Status -->
            <div class="col-2 filter-card">
              <label class="form-label small fw-bold text-dark mb-1 d-block"
                >Status</label
              >
              <select
                class="form-select form-select-sm bg-white border shadow-none select-filter-initial"
                [(ngModel)]="pendingStatus"
              >
                <option *ngFor="let st of statuses" [value]="st.value">
                  {{ st.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <!-- ── STAT CARDS ──────────────────────────────────────────────── style="min-width: 175px-->
          <div class="row">
            <div class="col-12">
              <div
                class="row m-0 align-items-stretch flex-nowrap custom-scroll-x p-0 gap-3"
              >
                <!-- Active Markets -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div class="stat-icon-filled bg-blue me-3">
                        <i class="fas fa-store"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>ACTIVE MARKETS</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.activeMarkets.value }}
                        </h3>
                        <div
                          class="small fw-medium"
                          [ngClass]="
                            stats.activeMarkets.up
                              ? 'text-success'
                              : 'text-danger'
                          "
                        >
                          <i
                            class="fas"
                            [ngClass]="
                              stats.activeMarkets.up
                                ? 'fa-arrow-up'
                                : 'fa-arrow-down'
                            "
                          ></i>
                          {{ stats.activeMarkets.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- GBP Health Score -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div class="stat-icon-filled bg-green me-3">
                        <i class="fas fa-star"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>GBP HEALTH SCORE</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.gbpHealthScore.value }}%
                        </h3>
                        <div
                          class="small fw-medium"
                          [ngClass]="
                            stats.gbpHealthScore.up
                              ? 'text-success'
                              : 'text-danger'
                          "
                        >
                          <i
                            class="fas"
                            [ngClass]="
                              stats.gbpHealthScore.up
                                ? 'fa-arrow-up'
                                : 'fa-arrow-down'
                            "
                          ></i>
                          {{ stats.gbpHealthScore.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Citation Consistency -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div class="stat-icon-filled bg-orange me-3">
                        <i class="fas fa-link"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>CITATION CONSISTENCY</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.citationConsistency.value }}%
                        </h3>
                        <div
                          class="small fw-medium"
                          [ngClass]="
                            stats.citationConsistency.up
                              ? 'text-success'
                              : 'text-danger'
                          "
                        >
                          <i
                            class="fas"
                            [ngClass]="
                              stats.citationConsistency.up
                                ? 'fa-arrow-up'
                                : 'fa-arrow-down'
                            "
                          ></i>
                          {{ stats.citationConsistency.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Average Rating -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div class="stat-icon-filled bg-purple me-3">
                        <i class="fas fa-message"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>AVERAGE RATING</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.averageRating.value }}
                        </h3>
                        <div
                          class="small fw-medium"
                          [ngClass]="
                            stats.averageRating.up
                              ? 'text-success'
                              : 'text-danger'
                          "
                        >
                          <i
                            class="fas"
                            [ngClass]="
                              stats.averageRating.up
                                ? 'fa-arrow-up'
                                : 'fa-arrow-down'
                            "
                          ></i>
                          {{ stats.averageRating.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Local Pack Visibility -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div class="stat-icon-filled bg-red me-3">
                        <i class="fas fa-map"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>LOCAL PACK VISIBILITY</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.localPackVisibility.value }}%
                        </h3>
                        <div
                          class="small fw-medium"
                          [ngClass]="
                            stats.localPackVisibility.up
                              ? 'text-success'
                              : 'text-danger'
                          "
                        >
                          <i
                            class="fas"
                            [ngClass]="
                              stats.localPackVisibility.up
                                ? 'fa-arrow-up'
                                : 'fa-arrow-down'
                            "
                          ></i>
                          {{ stats.localPackVisibility.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Critical Issues -->
                <div class="col p-0 pr-1 d-flex">
                  <div class="card shadow-sm border-0 bg-white w-100 mt-4">
                    <div class="card-body px-1 py-1 d-flex">
                      <div
                        class="stat-icon-filled bg-info me-3"
                        style="background-color: #008080 !important"
                      >
                        <i class="fas fa-exclamation-triangle"></i>
                      </div>
                      <div class="space-cards">
                        <div
                          class="text-uppercase fw-bold text-dark mb-1"
                          style="font-size: 0.63rem; letter-spacing: 0.5px"
                        >
                          <strong>CRITICAL ISSUES</strong>
                        </div>
                        <h3 class="mb-1 fw-bold text-dark">
                          {{ stats.criticalIssues.value }}
                        </h3>
                        <div
                          class="small fw-medium"
                          [ngClass]="
                            stats.criticalIssues.up
                              ? 'text-success'
                              : 'text-danger'
                          "
                        >
                          <i
                            class="fas"
                            [ngClass]="
                              stats.criticalIssues.up
                                ? 'fa-arrow-up'
                                : 'fa-arrow-down'
                            "
                          ></i>
                          {{ stats.criticalIssues.trend }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 d-flex">
          <div class="card shadow-sm mb-4 flex-grow-1 mt-0">
            <div class="card-header bg-white border-bottom-0 pb-0 px-0">
              <h4 class="fw-bold fs-6 mb-3 pl-3">
                <strong>LOCAL ISSUES QUEUE</strong>
                <i class="fas fa-info-circle text-muted ms-1 small pl-1"></i>
              </h4>
              <!-- Tab Navigation -->
              <ul
                class="nav nav-tabs nav-tabs-custom flex-nowrap custom-scroll-x px-0 pb-4 ul-tabs-custom"
              >
                <li class="nav-item" *ngFor="let tab of tabs">
                  <a
                    class="nav-link fw-bold"
                    [class.active]="activeTab === tab.key"
                    href="javascript:void(0)"
                    (click)="setTab(tab.key)"
                  >
                    <strong>{{ tab.label }}</strong>
                    <span class="badge bg-light border text-dark ms-1">{{
                      tab.count
                    }}</span>
                  </a>
                </li>
              </ul>
            </div>

            <div class="card-body p-0">
              <div class="table-responsive">
                <table class="table table-hover align-middle mb-0 text-sm">
                  <thead class="bg-light small text-uppercase">
                    <tr>
                      <th class="kw-url-mapping-header">
                        <strong>LOCATION</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>ISSUE TYPE</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>ISSUE DETAILS</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>IMPACT</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>STATUS</strong>
                      </th>
                      <th class="kw-url-mapping-header">
                        <strong>DETECTED</strong>
                      </th>
                      <th class="pe-3 text-end kw-url-mapping-header">
                        <strong>ACTION</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let issue of filteredIssues"
                      [class.table-active]="
                        issue.location === selectedIssue.location &&
                        issue.issueDetails === selectedIssue.issueDetails
                      "
                      (click)="selectIssue(issue)"
                      style="cursor: pointer"
                    >
                      <td class="fw-medium text-dark">{{ issue.location }}</td>
                      <td>{{ issue.issueType }}</td>
                      <td style="font-size: 0.78rem">
                        {{ issue.issueDetails }}
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill text-transformNone"
                          [ngClass]="
                            issue.impact === 'High'
                              ? 'bg-danger-light text-danger'
                              : 'bg-warning-light text-warning'
                          "
                        >
                          {{ issue.impact }}
                        </span>
                      </td>
                      <td>
                        <span
                          class="badge rounded-pill text-transformNone"
                          [class]="getStatusClass(issue.status)"
                        >
                          {{ issue.status }}
                        </span>
                      </td>
                      <td style="font-size: 0.78rem; white-space: nowrap">
                        {{ issue.detected }}
                      </td>
                      <td class="pe-3 text-end">
                        <a
                          href="javascript:void(0)"
                          class="text-primary text-decoration-none fw-medium"
                          style="font-size: 0.8rem"
                        >
                          {{ issue.recommendedAction }}
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Pagination -->
              <!-- <div
                class="d-flex justify-content-between align-items-center p-3 border-top bg-light"
              >
                <span class="small text-muted"
                  >Showing 1 to 8 of 58 results</span
                >
                <div class="d-flex gap-1">
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    <i class="fas fa-chevron-left"></i>
                  </button>
                  <button class="btn btn-sm btn-dark px-2">1</button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    2
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    3
                  </button>
                  <span class="px-2">...</span>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    8
                  </button>
                  <button class="btn btn-sm btn-outline-secondary px-2">
                    <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
                <select class="form-select form-select-sm w-auto">
                  <option>10 / page</option>
                </select>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- col-4: RIGHT COLUMN (Selected Location Review) -->
        <div class="col-6 d-flex">
          <div class="card shadow-sm mb-4 flex-grow-1 mt-0">
            <div
              class="card-header bg-white border-bottom-0 d-flex justify-content-between align-items-center pb-0 pt-3 p-2"
            >
              <h4 class="fw-bold text-uppercase mb-0 pl-2 small">
                <strong>SELECTED LOCATION REVIEW</strong>
              </h4>
              <button class="btn btn-sm btn-link text-muted">
                <i class="fas fa-times"></i>
              </button>
            </div>

            <div class="card-body pt-2 pl-2">
              <div class="d-flex align-items-center mb-2 pl-2 gap-2">
                <span class="text-dark fw-bold" style="font-size: 1rem">
                  <i class="fas fa-map-marker-alt text-primary me-2"></i
                  >{{ selectedIssue.location || "N/A" }}
                </span>
                <span
                  *ngIf="selectedIssue.activeMarket"
                  class="badge bg-success-light text-success text-transformNone"
                  >Active Market</span
                >
              </div>

              <div class="mb-3 pl-2" style="font-size: 0.8rem">
                <span class="text-dark">Primary Service: </span
                ><span class="text-dark fw-medium">{{
                  selectedIssue.primaryService || "N/A"
                }}</span
                ><br />
                <span class="text-dark">Market Priority: </span
                ><span class="text-dark fw-medium pl-2">{{
                  selectedIssue.marketPriority || "N/A"
                }}</span>
              </div>

              <!-- Key Metrics list -->
              <div
                class="mb-3 text-uppercase fw-bold text-dark font-size11 pl-2 border-top border-muted"
              >
                <h5><strong>Key Metrics</strong></h5>
              </div>
              <div class="table-responsive">
                <table
                  class="table table-sm table-borderless small mb-3 border-bottom"
                >
                  <tbody *ngIf="selectedIssue.keyMetrics">
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        GBP Health
                      </td>
                      <td
                        class="text-end text-success fw-bold"
                        style="font-size: 0.78rem"
                      >
                        <span
                          class="badge bg-success text-success rounded-pill"
                          [class]="
                            getSignalStatusClass(
                              selectedIssue.keyMetrics.gbpHealth
                            )
                          "
                          >{{ selectedIssue.keyMetrics.gbpHealth }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Citation Consistency
                      </td>
                      <td
                        class="text-end text-success fw-bold"
                        style="font-size: 0.78rem"
                      >
                        <span
                          class="badge bg-success text-success rounded-pill"
                          [class]="
                            getSignalStatusClass(
                              selectedIssue.keyMetrics.citationConsistency
                            )
                          "
                          >{{
                            selectedIssue.keyMetrics.citationConsistency
                          }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Average Rating
                      </td>
                      <td
                        class="text-end fw-bold text-dark"
                        style="font-size: 0.78rem"
                      >
                        {{ selectedIssue.keyMetrics.averageRating }}
                        <i class="fas fa-star text-warning"></i>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Total reviews
                      </td>
                      <td
                        class="text-end fw-semibold text-dark"
                        style="font-size: 0.78rem"
                      >
                        {{ selectedIssue.keyMetrics.totalReviews }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Local Pack Visibility
                      </td>
                      <td
                        class="text-end fw-bold text-warning"
                        style="font-size: 0.78rem"
                      >
                        <span
                          class="badge bg-warning text-warning rounded-pill"
                          [class]="
                            getSignalStatusClass(
                              selectedIssue.keyMetrics.localPackVisibility
                            )
                          "
                          >{{
                            selectedIssue.keyMetrics.localPackVisibility
                          }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Visibility Trend (30d)
                      </td>
                      <td
                        class="text-end fw-bold"
                        [ngClass]="
                          selectedIssue.keyMetrics.visibilityTrendUp
                            ? 'text-success'
                            : 'text-danger'
                        "
                        style="font-size: 0.78rem"
                      >
                        <i
                          class="fas"
                          [ngClass]="
                            selectedIssue.keyMetrics.visibilityTrendUp
                              ? 'fa-arrow-up'
                              : 'fa-arrow-down'
                          "
                        ></i>
                        {{ selectedIssue.keyMetrics.visibilityTrend }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Review Velocity (30d)
                      </td>
                      <td
                        class="text-end text-dark fw-bold"
                        style="font-size: 0.78rem"
                      >
                        {{ selectedIssue.keyMetrics.reviewVelocity }}
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        NAP Status
                      </td>
                      <td class="text-end fw-bold" style="font-size: 0.78rem">
                        <span
                          class="badge bg-danger text-danger rounded-pill"
                          [class]="
                            getSignalStatusClass(
                              selectedIssue.keyMetrics.napStatus
                            )
                          "
                          >{{ selectedIssue.keyMetrics.napStatus }}</span
                        >
                      </td>
                    </tr>
                    <tr>
                      <td class="text-dark" style="font-size: 0.78rem">
                        Service Area
                      </td>
                      <td class="text-end text-dark" style="font-size: 0.78rem">
                        {{ selectedIssue.keyMetrics.serviceArea }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Top Issue block -->
              <div class="p-3 rounded mb-0" *ngIf="selectedIssue.topIssue">
                <h5
                  class="small fw-bold text-uppercase mb-2 text-dark font-size11"
                >
                  <strong>TOP ISSUE</strong>
                </h5>
                <span class="badge bg-danger-light text-danger mb-2">{{
                  selectedIssue.topIssue.title
                }}</span>
                <p class="small text-muted mb-2 lh-sm">
                  {{ selectedIssue.topIssue.description }}
                </p>
                <div class="text-end">
                  <a
                    href="javascript:void(0)"
                    class="small text-primary text-decoration-none fw-bold"
                  >
                    View all issues ({{ selectedIssue.topIssue.totalIssues }})
                    <i class="fas fa-arrow-right ml-1"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right: Signals & Recent Local Activity Card (col-4) -->
        <div class="col-6 pl-0 d-flex">
          <div class="card shadow-sm mt-0 mb-4 flex-grow-1">
            <div class="card-body p-3">
              <!-- Signals Table -->
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <h4 class="small fw-bold text-uppercase mb-0 text-dark">
                  <strong>RELATED ACTIVITY</strong>
                </h4>
                <a
                  href="javascript:void(0)"
                  class="small text-decoration-none text-primary"
                  style="font-size: 0.75rem"
                  >View all activity</a
                >
              </div>
              <div class="table-responsive mb-3">
                <table
                  class="table table-sm table-borderless small mb-0 align-middle"
                >
                  <thead
                    class="text-uppercase text-muted border-bottom font-size9"
                  >
                    <tr>
                      <th class="head-table"><strong>SIGNAL</strong></th>
                      <th class="head-table"><strong>TO</strong></th>
                      <th class="head-table"><strong>STATUS</strong></th>
                      <th class="head-table"><strong>DATE</strong></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let sig of signals" class="border-bottom-0">
                      <td class="fw-semibold text-dark">{{ sig.signal }}</td>
                      <td class="text-primary">{{ sig.to }}</td>
                      <td>
                        <span
                          class="badge rounded-pill text-transformNone"
                          [class]="getSignalStatusClass(sig.status)"
                        >
                          {{ sig.status }}
                        </span>
                      </td>
                      <td class="text-muted" style="font-size: 0.7rem">
                        {{ sig.date }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Recent Local Activity -->
              <div
                class="d-flex justify-content-between align-items-center border-top pt-3 mb-2"
              >
                <h4 class="small fw-bold text-uppercase mb-0 text-dark">
                  <strong>RECENT LOCAL ACTIVITY</strong>
                </h4>
                <a
                  href="javascript:void(0)"
                  class="small text-decoration-none text-primary fw-medium"
                  style="font-size: 0.72rem"
                  >View all activity &rarr;</a
                >
              </div>
              <div
                class="activity-list custom-scroll-x pt-1"
                style="font-size: 0.75rem"
              >
                <div style="min-width: 500px">
                  <div
                    *ngFor="let act of recentLocalActivity"
                    class="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom border-light"
                  >
                    <!-- Activity Text -->
                    <span
                      class="text-dark fw-medium pe-2 text-truncate"
                      style="flex: 1 1 auto; min-width: 250px"
                      title="{{ act.text }}"
                    >
                      {{ act.text }}
                    </span>
                    <!-- Date -->
                    <span
                      class="text-muted text-nowrap px-3"
                      style="width: 160px; font-size: 0.7rem"
                    >
                      {{ act.date }}
                    </span>
                    <!-- Actor -->
                    <span
                      class="text-dark text-nowrap text-end pl-2"
                      style="width: 70px; font-size: 0.7rem"
                    >
                      By {{ act.actor }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── BOTTOM CARDS GRID (5 COLUMNS) ─────────────────────────────── -->
      <div class="row g-3 mb-4">
        <!-- Market Overview -->
        <div class="col pr-0 d-flex">
          <div class="card shadow-sm h-100 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex justify-content-between align-items-center flex-wrap gap-2"
            >
              <h4 class="fw-bold text-uppercase small mb-0 d-inline-flex gap-1">
                <strong>MARKET OVERVIEW</strong>
                <i
                  class="fas fa-info-circle text-muted small"
                  style="font-size: 0.7rem; cursor: pointer"
                ></i>
              </h4>
            </div>
            <div class="card-body p-3 custom-scroll-x" style="overflow-x: auto">
              <div
                class="d-flex flex-row align-items-center gap-3"
                style="min-width: 210px"
              >
                <!-- Conic Gradient Donut Chart -->
                <div
                  class="eligibility-donut flex-shrink-0"
                  [style.background]="
                    'conic-gradient(#198754 0% ' +
                    marketOverview.active.pct +
                    '%, #fd7e14 ' +
                    marketOverview.active.pct +
                    '% ' +
                    (marketOverview.active.pct + marketOverview.growth.pct) +
                    '%, #0d6efd ' +
                    (marketOverview.active.pct + marketOverview.growth.pct) +
                    '% ' +
                    (marketOverview.active.pct +
                      marketOverview.growth.pct +
                      marketOverview.expansion.pct) +
                    '%, #adb5bd ' +
                    (marketOverview.active.pct +
                      marketOverview.growth.pct +
                      marketOverview.expansion.pct) +
                    '% 100%)'
                  "
                  style="
                    border: none !important;
                    width: 80px;
                    height: 80px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                  "
                >
                  <div
                    class="bg-white rounded-circle d-flex flex-column align-items-center justify-content-center"
                    style="width: 64px; height: 64px"
                  >
                    <span
                      class="eligibility-pct fw-bold text-dark mb-0 fs-4"
                      style="line-height: 1"
                      >{{ marketOverview.score }}</span
                    >
                    <span
                      class="eligibility-label text-muted text-center"
                      style="font-size: 0.55rem; line-height: 1.1"
                      >Total Markets</span
                    >
                  </div>
                </div>
                <div class="flex-grow-1 pl-1" style="font-size: 0.75rem">
                  <div
                    class="d-flex justify-content-between align-items-center mb-1"
                  >
                    <span
                      ><span
                        class="dot dot-green me-1"
                        style="background-color: #198754"
                      ></span>
                      Active</span
                    >
                    <span class="fw-medium text-dark"
                      >{{ marketOverview.active.count }} ({{
                        marketOverview.active.pct
                      }}%)</span
                    >
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center mb-1"
                  >
                    <span
                      ><span
                        class="dot dot-orange me-1"
                        style="background-color: #fd7e14"
                      ></span>
                      Growth</span
                    >
                    <span class="fw-medium text-dark"
                      >{{ marketOverview.growth.count }} ({{
                        marketOverview.growth.pct
                      }}%)</span
                    >
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center mb-1"
                  >
                    <span
                      ><span
                        class="dot dot-blue me-1"
                        style="background-color: #0d6efd"
                      ></span>
                      Expansion</span
                    >
                    <span class="fw-medium text-dark"
                      >{{ marketOverview.expansion.count }} ({{
                        marketOverview.expansion.pct
                      }}%)</span
                    >
                  </div>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span
                      ><span
                        class="dot dot-grey me-1"
                        style="background-color: #adb5bd"
                      ></span>
                      Not Active</span
                    >
                    <span class="fw-medium text-dark"
                      >{{ marketOverview.notActive.count }} ({{
                        marketOverview.notActive.pct
                      }}%)</span
                    >
                  </div>
                </div>
              </div>
              <div
                class="d-flex justify-content-end w-100 pt-2 border-top mt-3"
              >
                <a
                  href="javascript:void(0)"
                  class="small text-decoration-none text-primary fw-medium"
                  style="font-size: 0.72rem"
                >
                  View all markets &rarr;
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Local Pack Visibility -->
        <div class="col pr-0 d-flex">
          <div class="card shadow-sm h-100 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex justify-content-between align-items-center flex-wrap gap-2"
            >
              <h4 class="fw-bold text-uppercase small mb-0 d-inline-flex gap-1">
                <strong>LOCAL PACK VISIBILITY</strong>
                <i
                  class="fas fa-info-circle text-muted small"
                  style="font-size: 0.7rem; cursor: pointer"
                ></i>
              </h4>
              <a
                href="javascript:void(0)"
                class="small text-decoration-none text-primary fw-medium text-nowrap"
                style="font-size: 0.72rem"
              >
                View full report &rarr;
              </a>
            </div>
            <div class="card-body p-3 custom-scroll-x" style="overflow-x: auto">
              <div style="min-width: 210px">
                <div
                  *ngFor="let item of localPackVisibilityList"
                  class="d-flex justify-content-between align-items-center mb-2"
                  style="font-size: 0.75rem"
                >
                  <span
                    class="text-truncate text-dark fw-medium"
                    style="max-width: 105px"
                    title="{{ item.name }}"
                    >{{ item.name }}</span
                  >
                  <div
                    class="d-flex align-items-center flex-grow-1 mx-2"
                    style="height: 8px; position: relative"
                  >
                    <!-- Track -->
                    <div
                      style="
                        position: absolute;
                        left: 0;
                        right: 0;
                        height: 2px;
                        background-color: #e9ecef;
                        z-index: 1;
                      "
                    ></div>
                    <!-- Progress Bar with Left Arrowhead -->
                    <div
                      class="d-flex align-items-center"
                      [style.width.%]="item.pct"
                      style="
                        position: absolute;
                        left: 0;
                        height: 8px;
                        z-index: 2;
                      "
                    >
                      <!-- Triangle Arrowhead -->
                      <div
                        [style.border-right-color]="item.color || '#198754'"
                        style="
                          width: 0;
                          height: 0;
                          border-top: 4px solid transparent;
                          border-bottom: 4px solid transparent;
                          border-right: 6px solid #198754;
                          margin-right: -1px;
                        "
                      ></div>
                      <!-- Bar line -->
                      <div
                        [style.background-color]="item.color || '#198754'"
                        style="flex-grow: 1; height: 2px"
                      ></div>
                    </div>
                  </div>
                  <span
                    class="fw-bold text-dark text-end"
                    style="min-width: 32px"
                    >{{ item.pct }}%</span
                  >
                </div>
              </div>
              <div
                class="d-flex justify-content-end w-100 pt-2 border-top mt-3"
              >
                <a
                  href="javascript:void(0)"
                  class="small text-decoration-none text-primary fw-medium text-nowrap"
                  style="font-size: 0.72rem"
                >
                  View by keywords &rarr;
                </a>
              </div>
            </div>
          </div>
        </div>

        <!-- Average Rating -->
        <div class="col pr-0 d-flex">
          <div class="card shadow-sm h-100 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex justify-content-between align-items-center flex-wrap gap-2"
            >
              <h4 class="fw-bold text-uppercase small mb-0 d-inline-flex gap-1">
                <strong>AVERAGE RATING</strong>
                <i
                  class="fas fa-info-circle text-muted small"
                  style="font-size: 0.7rem; cursor: pointer"
                ></i>
              </h4>
              <a
                href="javascript:void(0)"
                class="small text-decoration-none text-primary fw-medium text-nowrap"
                style="font-size: 0.72rem"
              >
                View full report &rarr;
              </a>
            </div>
            <div class="card-body p-3 custom-scroll-x" style="overflow-x: auto">
              <div style="min-width: 210px">
                <div
                  *ngFor="let item of averageRatingsList"
                  class="d-flex justify-content-between align-items-center mb-2"
                  style="font-size: 0.75rem"
                >
                  <span class="text-dark fw-medium">{{ item.name }}</span>
                  <span
                    class="fw-bold text-dark d-flex align-items-center gap-1"
                  >
                    {{ item.rating }}
                    <i
                      class="fas fa-star text-secondary"
                      style="font-size: 10px; color: #475569"
                    ></i>
                  </span>
                </div>
                <div
                  class="d-flex justify-content-between align-items-center border-top pt-2 mt-2"
                  style="font-size: 0.75rem"
                >
                  <span class="text-muted fw-semibold"
                    >Industry Benchmark: 4.0</span
                  >
                  <span
                    class="fw-bold text-dark d-flex align-items-center gap-1"
                  >
                    4.0
                    <i
                      class="fas fa-star text-secondary"
                      style="font-size: 10px; color: #475569"
                    ></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row g-3 mb-4">
        <!-- Reviews Over Time -->
        <div class="col pr-0 d-flex">
          <div class="card shadow-sm h-100 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex justify-content-between align-items-center flex-wrap gap-2"
            >
              <h4 class="fw-bold text-uppercase small mb-0 d-inline-flex gap-1">
                <strong>REVIEWS OVER TIME</strong>
                <i
                  class="fas fa-info-circle text-muted small"
                  style="font-size: 0.7rem; cursor: pointer"
                ></i>
              </h4>
              <a
                href="javascript:void(0)"
                class="small text-decoration-none text-primary fw-medium text-nowrap"
                style="font-size: 0.72rem"
              >
                View full report &rarr;
              </a>
            </div>
            <div class="card-body p-3 custom-scroll-x" style="overflow-x: auto">
              <div style="min-width: 210px">
                <!-- Main metric row -->
                <div
                  class="d-flex justify-content-between align-items-center mb-2"
                >
                  <div class="d-flex align-items-baseline gap-1">
                    <span
                      class="fs-3 fw-bold text-dark"
                      style="line-height: 1"
                      >{{ reviewsOverTime.totalReviews }}</span
                    >
                    <span class="text-muted" style="font-size: 0.65rem"
                      >Total Reviews</span
                    >
                  </div>
                  <div
                    class="text-success small fw-semibold d-flex align-items-center gap-1"
                    style="font-size: 0.7rem"
                  >
                    <i class="fas fa-arrow-up"></i>
                    <span>{{ reviewsOverTime.trend }}</span>
                  </div>
                </div>
                <!-- Line Chart Representation -->
                <div class="d-flex align-items-stretch" style="height: 55px">
                  <!-- Y Axis Labels -->
                  <div
                    class="d-flex flex-column justify-content-between text-muted text-end pe-2"
                    style="
                      font-size: 0.6rem;
                      width: 22px;
                      line-height: 1;
                      padding: 2px 0;
                    "
                  >
                    <span>200</span>
                    <span>150</span>
                    <span>100</span>
                    <span>50</span>
                    <span>0</span>
                  </div>
                  <!-- SVG Trend Area -->
                  <div
                    class="flex-grow-1 position-relative"
                    style="height: 100%"
                  >
                    <svg
                      class="w-100 h-100"
                      viewBox="0 0 100 80"
                      preserveAspectRatio="none"
                      style="overflow: visible"
                    >
                      <defs>
                        <linearGradient
                          id="chartGrad"
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="1"
                        >
                          <stop
                            offset="0%"
                            stop-color="#198754"
                            stop-opacity="0.15"
                          />
                          <stop
                            offset="100%"
                            stop-color="#198754"
                            stop-opacity="0.0"
                          />
                        </linearGradient>
                      </defs>
                      <!-- Horizontal Grid Lines -->
                      <line
                        x1="0"
                        y1="2"
                        x2="100"
                        y2="2"
                        stroke="#f1f5f9"
                        stroke-width="1"
                      />
                      <line
                        x1="0"
                        y1="21"
                        x2="100"
                        y2="21"
                        stroke="#f1f5f9"
                        stroke-width="1"
                      />
                      <line
                        x1="0"
                        y1="40"
                        x2="100"
                        y2="40"
                        stroke="#f1f5f9"
                        stroke-width="1"
                      />
                      <line
                        x1="0"
                        y1="59"
                        x2="100"
                        y2="59"
                        stroke="#f1f5f9"
                        stroke-width="1"
                      />
                      <line
                        x1="0"
                        y1="78"
                        x2="100"
                        y2="78"
                        stroke="#e2e8f0"
                        stroke-width="1"
                      />

                      <!-- Trend Shaded Area -->
                      <path
                        d="M0,45 C15,43 30,35 45,30 C60,26 75,22 90,16 C95,14 100,12 100,12 L100,78 L0,78 Z"
                        fill="url(#chartGrad)"
                      ></path>
                      <!-- Trend Line Path -->
                      <path
                        d="M0,45 C15,43 30,35 45,30 C60,26 75,22 90,16 C95,14 100,12 100,12"
                        fill="none"
                        stroke="#198754"
                        stroke-width="1.8"
                      ></path>
                      <!-- Endpoint Indicator Dot -->
                      <circle cx="100" cy="12" r="2.5" fill="#198754"></circle>
                    </svg>
                  </div>
                </div>
                <!-- X Axis Labels -->
                <div
                  class="d-flex justify-content-between text-muted mt-2"
                  style="font-size: 0.6rem; margin-left: 22px; padding-top: 1px"
                >
                  <span>Apr 19</span>
                  <span>Apr 26</span>
                  <span>May 3</span>
                  <span>May 10</span>
                  <span>May 17</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Citation Consistency -->
        <div class="col d-flex">
          <div class="card shadow-sm h-100 mt-0 flex-grow-1">
            <div
              class="card-header bg-white border-bottom-0 pb-0 d-flex justify-content-between align-items-center flex-wrap gap-2"
            >
              <h4 class="fw-bold text-uppercase small mb-0 d-inline-flex gap-1">
                <strong>CITATION CONSISTENCY</strong>
                <i
                  class="fas fa-info-circle text-muted small"
                  style="font-size: 0.7rem; cursor: pointer"
                ></i>
              </h4>
              <a
                href="javascript:void(0)"
                class="small text-decoration-none text-primary fw-medium text-nowrap"
                style="font-size: 0.72rem"
              >
                View full report &rarr;
              </a>
            </div>
            <div class="card-body p-3 custom-scroll-x" style="overflow-x: auto">
              <div style="min-width: 210px">
                <div
                  *ngFor="let item of citationConsistencyList"
                  class="d-flex justify-content-between align-items-center mb-2"
                  style="font-size: 0.75rem"
                >
                  <span class="text-dark fw-medium">{{ item.name }}</span>
                  <span class="fw-bold text-dark">{{ item.pct }}%</span>
                </div>
              </div>
              <div
                class="d-flex justify-content-end w-100 pt-2 border-top mt-3"
              >
                <a
                  href="javascript:void(0)"
                  class="small text-decoration-none text-primary fw-medium text-nowrap"
                  style="font-size: 0.72rem"
                >
                  View inconsistent citations &rarr;
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ── BOTTOM ROW (ACTION CENTER & SIGNALS/ACTIVITY) ──────────────── -->
      <div class="row">
        <!-- Left: Local Action Center (col-8) -->
        <div class="col-12 d-flex">
          <div
            class="card shadow-sm mt-0 h-100 flex-grow-1"
            style="border: 1px solid #c2e0ff"
          >
            <div
              class="card-header bg-white border-bottom-0 pb-0 pt-3 px-3 d-flex align-items-center"
            >
              <h4 class="fw-bold text-uppercase small mb-0 me-3">
                <strong>LOCAL ACTION CENTER</strong>
              </h4>
              <span
                class="badge bg-success-light text-success text-transformNone"
                >1 issue selected</span
              >
            </div>

            <div class="card-body p-1">
              <!-- Scrollable Wrapper for Action Center Columns -->
              <div class="custom-scroll-x pb-2">
                <!-- <div
                  *ngIf="selectedIssue.actionCenter"
                  class="d-flex flex-nowrap align-items-stretch gap-3 pb-2"
                  style="min-width: 1040px"
                > -->
                <div
                  *ngIf="selectedIssue.actionCenter"
                  class="row align-items-stretch flex-nowrap mx-0"
                  style="min-width: 900px"
                >
                  <div class="col-12 pt-3 d-flex">
                    <!-- SELECTED ACTION info -->
                    <div
                      class="col-3 d-flex flex-column justify-content-between pe-3 border-end pr-1"
                    >
                      <div>
                        <h6
                          class="small fw-bold text-dark mb-1 text-uppercase"
                          style="font-size: 0.65rem; letter-spacing: 0.5px"
                        >
                          <strong>SELECTED ACTION</strong>
                        </h6>
                        <p class="fw-bold text-dark font-size12 mb-3">
                          <strong>{{
                            selectedIssue.actionCenter.selectedAction
                          }}</strong>
                        </p>
                      </div>
                      <div class="d-flex flex-column gap-1">
                        <div
                          class="d-flex justify-content-between align-items-center py-2"
                        >
                          <span
                            class="text-dark fw-bold"
                            style="font-size: 0.62rem; letter-spacing: 0.3px"
                            ><strong>TARGET LOCATION</strong></span
                          >
                          <span class="small fw-semibold text-dark">{{
                            selectedIssue.actionCenter.targetLocation
                          }}</span>
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center py-2"
                        >
                          <span
                            class="text-dark fw-bold"
                            style="font-size: 0.62rem; letter-spacing: 0.3px"
                            ><strong>ELEMENT</strong></span
                          >
                          <span
                            class="small fw-semibold text-dark text-truncate ms-2"
                            style="max-width: 110px"
                            title="{{ selectedIssue.actionCenter.element }}"
                            >{{ selectedIssue.actionCenter.element }}</span
                          >
                        </div>
                        <div
                          class="d-flex justify-content-between align-items-center py-2"
                        >
                          <span
                            class="text-dark fw-bold"
                            style="font-size: 0.62rem; letter-spacing: 0.3px"
                            ><strong>DECISION ORIGIN</strong></span
                          >
                          <span class="small fw-semibold text-dark">{{
                            selectedIssue.actionCenter.decisionOrigin
                          }}</span>
                        </div>
                      </div>
                    </div>

                    <!-- CURRENT details -->
                    <div
                      class="col-4 border rounded bg-white p-3 d-flex flex-column justify-content-start"
                      style="
                        border-color: #cbd5e1 !important;
                        max-height: 152px;
                      "
                    >
                      <h6
                        class="small fw-bold text-dark mb-2 text-uppercase"
                        style="font-size: 0.65rem; letter-spacing: 0.5px"
                      >
                        <strong>CURRENT</strong>
                      </h6>
                      <p
                        class="small text-dark mb-0 lh-base"
                        style="font-size: 0.75rem; white-space: pre-line"
                      >
                        {{ selectedIssue.actionCenter.currentText }}
                      </p>
                    </div>

                    <!-- Arrow divider -->
                    <div
                      class="d-flex align-items-center justify-content-center px-1"
                      style="flex: 0 0 20px"
                    >
                      <i class="fas fa-arrow-right text-muted"></i>
                    </div>

                    <!-- PROPOSED details -->
                    <div
                      class="col-4 border rounded p-3 d-flex flex-column justify-content-start"
                      style="
                        background-color: #f0fdf4;
                        border-color: #bbf7d0 !important;
                        max-height: 152px;
                      "
                    >
                      <h6
                        class="small fw-bold text-dark mb-2 text-uppercase"
                        style="font-size: 0.65rem; letter-spacing: 0.5px"
                      >
                        <strong>PROPOSED</strong>
                      </h6>
                      <p
                        class="small fw-medium mb-0 lh-base text-dark"
                        style="font-size: 0.75rem; white-space: pre-line"
                      >
                        {{ selectedIssue.actionCenter.proposedText }}
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  *ngIf="selectedIssue.actionCenter"
                  class="row align-items-stretch flex-nowrap mx-0"
                  style="max-width: 500px"
                >
                  <div class="col-12 pt-3 d-flex">
                    <!-- AI RECOMMENDATION & CONFIDENCE -->
                    <div class="d-flex align-items-stretch ps-3 ms-2 pl-1">
                      <div
                        class="col-auto d-flex flex-column justify-content-between flex-grow-1 pe-3"
                        style="max-height: 152px"
                      >
                        <div>
                          <h6
                            class="small fw-bold text-primary mb-2 text-uppercase"
                            style="font-size: 0.65rem; letter-spacing: 0.5px"
                          >
                            AI RECOMMENDATION
                          </h6>
                          <p
                            class="small text-muted mb-2 lh-sm"
                            style="font-size: 0.75rem"
                          >
                            {{ selectedIssue.actionCenter.aiRecommendation }}
                          </p>
                        </div>
                        <a
                          href="javascript:void(0)"
                          class="small text-primary text-decoration-none fw-medium d-inline-flex align-items-center mt-1"
                        >
                          View full rationale
                          <i
                            class="fas fa-arrow-right ms-1"
                            style="font-size: 0.7rem"
                          ></i>
                        </a>
                      </div>

                      <div
                        class="border-end mx-2"
                        style="border-color: #cbd5e1 !important; height: 100%"
                      ></div>

                      <div
                        class="col d-flex align-items-center justify-content-center ps-2 flex-shrink-0"
                      >
                        <div
                          class="progress-circle-wrapper"
                          style="position: relative; width: 70px; height: 70px"
                        >
                          <div
                            class="progress-circle"
                            [style.background]="
                              'conic-gradient(#198754 0% ' +
                              selectedIssue.actionCenter.aiConfidence +
                              '%, #e2e8f0 ' +
                              selectedIssue.actionCenter.aiConfidence +
                              '% 100%)'
                            "
                            style="
                              width: 70px;
                              height: 70px;
                              border-radius: 50%;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              position: relative;
                            "
                          >
                            <div
                              class="bg-white rounded-circle d-flex flex-column align-items-center justify-content-center"
                              style="width: 58px; height: 58px"
                            >
                              <span
                                class="text-dark fw-bold"
                                style="font-size: 0.95rem; line-height: 1"
                                >{{
                                  selectedIssue.actionCenter.aiConfidence
                                }}%</span
                              >
                              <span
                                class="text-success fw-bold text-uppercase"
                                style="
                                  font-size: 0.52rem;
                                  margin-top: 2px;
                                  letter-spacing: 0.2px;
                                "
                                >{{
                                  selectedIssue.actionCenter.riskLevel
                                }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Action Buttons Bar -->
              <div class="border-top pt-3 mt-4">
                <div class="custom-scroll-x pb-2">
                  <div
                    class="d-flex gap-2 flex-nowrap w-100"
                    style="min-width: 860px"
                  >
                    <button
                      class="btn btn-success fw-medium btn-desicion-mapping flex-grow-1"
                      (click)="approveAction()"
                      [disabled]="saving"
                      style="
                        background: linear-gradient(
                          135deg,
                          #10b981 0%,
                          #059669 100%
                        );
                        border-color: #059669;
                        color: white;
                      "
                    >
                      <i class="fas fa-check me-2"></i> Approve &amp; Implement
                    </button>
                    <button
                      class="btn btn-outline-secondary fw-medium btn-desicion-mapping bg-white text-dark flex-grow-1"
                      style="border-color: #cbd5e1"
                    >
                      <i class="fas fa-pencil-alt me-2"></i> Edit Action
                    </button>
                    <button
                      class="btn btn-outline-primary border border-primary fw-medium btn-desicion-mapping bg-white flex-grow-1"
                      style="color: #a855f7; border-color: #a855f7 !important"
                    >
                      <i class="fas fa-magic me-2"></i> Ask AI to Reconsider
                    </button>
                    <button
                      class="btn btn-outline-danger border border-danger fw-medium btn-desicion-mapping bg-white text-danger flex-grow-1"
                      style="border-color: #fca5a5"
                      (click)="rejectAction()"
                      [disabled]="saving"
                    >
                      <i class="fas fa-times-circle me-2"></i> Reject
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary fw-medium btn-desicion-mapping bg-white text-dark flex-grow-1 d-flex justify-content-between align-items-center"
                      style="border-color: #cbd5e1"
                    >
                      <span
                        ><i class="fas fa-paper-plane me-2 text-primary"></i>
                        Create Signal</span
                      >
                      <i
                        class="fas fa-chevron-down ms-1 text-muted"
                        style="font-size: 0.65rem"
                      ></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-outline-secondary fw-semibold btn-desicion-mapping bg-white text-dark flex-grow-1 d-flex justify-content-between align-items-center"
                      style="border-color: #cbd5e1"
                    >
                      <span
                        ><i class="fas fa-ellipsis-h me-2"></i> More
                        Actions</span
                      >
                      <i
                        class="fas fa-chevron-down ms-1 text-muted"
                        style="font-size: 0.65rem"
                      ></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer note -->
      <!-- <div
        class="mt-3 text-muted small d-flex align-items-center border-top pt-3"
      >
        <i class="fas fa-info-circle me-2 pr-2"></i>
        Local SEO manages geographic presence and visibility. Content changes
        are handled by On-Page SEO. Technical issues are handled by Technical
        QA. Assets and content needs are routed through Request Intake.
      </div> -->
    </div>

    <!-- Loading spinner -->
    <div
      *ngIf="loading"
      class="d-flex justify-content-center align-items-center"
      style="min-height: 400px"
    >
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</div>
